<template>
	<div class="vxe-form--item-inner">
		<vxe-pulldown @hide-panel="submit" :ref="pulldownRef" style="width: auto;height: auto;box-sizing: border-box;">
			<template #default>
				<vxe-button status="success" icon="vxe-icon-arrow-down" style="margin-right: 10px;"
					@click="buttonClick">更多筛选</vxe-button>
			</template>
			<template #dropdown>
				<div class="box">
					<vxe-checkbox-group v-model="showItems" @change="submit">
						<vxe-checkbox v-for="(item,index) in item" :key="index" class="checkbox" :label="item.field"
							:content="item.title"></vxe-checkbox>
					</vxe-checkbox-group>
					<hr>
					<el-button @click="initItem('init')" style="width: 100%;color: #F56C6C;" type="text"
						size="mini">初始化</el-button>
				</div>
			</template>
		</vxe-pulldown>
		<vxe-button status="primary" type="submit">查询</vxe-button>
		<searchdetail ref="searchdetail" v-if="sonlistfield.length!=0" :sonlistfield="sonlistfield" :formsConfig="formsConfig" />
		<vxe-button type="reset" @click="reset">重置</vxe-button>
		<div class="flex" style="align-items: center;" v-if="table && table.moduleName">
			<div style="margin-left: 10px;display: inline-block;">
				<el-select size="mini" v-model="customFilter" placeholder="保存为快捷查询" @change="customFilterChange"
					clearable>
					<el-option v-for="(item,index) in customFilterOption" :key="index" :value="item.value">
						<div class="flex" style="justify-content: space-between;">
							<div>{{item.label}}</div>
							<el-button type="text" @click.stop="deleteFilter(item)" size="mini"
								style="color: #F56C6C;margin-left: 20px;">删除</el-button>
						</div>
					</el-option>
				</el-select>
			</div>
			<el-button style="margin-left: 5px;font-size: 20px;" icon="el-icon-circle-plus" type="text"
				@click="savefilter" size="mini"></el-button>
		</div>
	</div>
</template>
<style>
	.vxe-pulldown .vxe-pulldown--content {
		line-height: 30px;
	}
</style>
<style scoped>
	.box {
		box-sizing: border-box;
		padding: 10px;

		box-shadow: 0px 0px 4px lightgray;
	}

	.checkbox {
		position: relative;
		width: 100%;
		margin: 2px 10px;

	}
</style>
<script>
	import searchdetail from './searchdetail.vue'
	export default {
		props: {
			tableFormInfo: {
				default: () => {
					return null
				}
			},
			table: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				customFilter: null,
				customFilterOption: [],
				pulldownRef: 'pulldown_' + Math.random(),
				visible: false,
				showItems: [],
				item: [],
				sonlistfield:[],
				formsConfig:null
			}
		},
		created() {


		},
		mounted() {
			this.sonlistfield = (this.table && this.table.sonlistfield) ? this.table.sonlistfield : []
			this.formsConfig = (this.table && this.table.formsConfig) ? this.table.formsConfig : null
			this.initItem()
		},
		watch: {

		},
		computed: {

		},
		methods: {
			initItem(type = null) {
				if (type == 'init') {
					window.systemMethods.setLocalConfig('modulefilter', this.tableFormInfo.$form.$parent.id, null)
				}
				if (this.tableFormInfo) {
					this.showItems = []
					let form = this.tableFormInfo.$form
					this.item = form.getItems()
					//console.log(this.item )
					this.item = this.item.filter((item) => {
						return item.field
					})
					this.item.forEach((item) => {
						if (item.itemRender.props && item.itemRender.props.defaultshow) {
							item.folding = false
							this.showItems.push(item.field)
						} else {
							item.folding = true
						}
					})
					//console.log(this.showItems,123123)
					if (this.showItems.length == 0) {
						this.item.forEach((item, index) => {
							if (index < 3) {
								item.folding = false
								this.showItems.push(item.field)
							} else {
								item.folding = true
							}
						})
					}
					//console.log(this.showItems,this.item)
					let configItems = window.systemMethods.getLocalConfig('modulefilter', this.tableFormInfo.$form.$parent
						.id)
					if (configItems) {
						this.item.forEach((item) => {
							//console.log(item.itemRender,123)
							if (item.itemRender && item.itemRender.props && item.itemRender.props.systemitem) {
								configItems.unshift(item.field)
							}
						})
						this.showItems = configItems
						this.submit()
					}
					if (this.table && this.table.moduleName) {
						this.getStaffConfig()
					}

				}
			},
			reset() {
				this.$refs.searchdetail.reset()
				this.customFilter = null
			},
			customFilterChange(e) {
				let target = this.customFilterOption.find((item) => {
					return item.value == e
				})
				if (target) {
					for (let i in target.config) {
						if (Object.keys(this.tableFormInfo.data).includes(i)) {
							this.tableFormInfo.data[i] = target.config[i]
						}
					}
					this.table.customreload()
				}

			},
			savefilter() {
				// console.log(this.tableFormInfo)
				// console.log(this.table.moduleName)
				this.$prompt('请输入名称', '保存查询配置').then((res) => {
					//console.log(res, this.tableFormInfo.data, this.table.moduleName)
					this.$api.staff.setStaffConfig({
						type: 'module',
						configname: res.value,
						config: this.tableFormInfo.data,
						modulename: this.table.moduleName,
					}).then(() => {
						this.table.customreload()
						this.getStaffConfig()
						this.customFilter = res.value
						this.$message.success('操作成功')
					})
				})
				// this.tableFormInfo.data.code = '202412050002'
				// this.table.customreload()
			},
			deleteFilter(e) {
				let target = this.customFilterOption.find((item) => {
					return item.id == e.id
				})
				if (target) {
					this.$api.staff.delStaffConfig({
						id: e.id,
					}).then(() => {
						this.customFilter = null
						this.customFilterOption = this.customFilterOption.filter((item) => {
							return item.id != e.id
						})
					})
				}

			},
			getStaffConfig() {
				this.$api.staff.getStaffConfig({
					type: 'module',
					modulename: this.table.moduleName,
				}).then((res) => {
					this.customFilterOption = []
					res.forEach((item) => {
						this.customFilterOption.push({
							id: item.id,
							label: item.configname,
							value: item.configname,
							config: item.config,
						})
					})
				})
			},
			submit() {
				this.$nextTick(() => {
					this.item.forEach((item) => {
						item.folding = true
					})
					this.showItems.forEach((item) => {
						let obj = this.item.find((_item) => {
							return _item.field == item
						})
						if (obj) {
							obj.folding = false
						}
					})
					window.systemMethods.setLocalConfig('modulefilter', this.tableFormInfo.$form.$parent.id, this
						.showItems)
				})
			},
			buttonClick() {
				const $pulldown = this.$refs[this.pulldownRef]
				if ($pulldown) {
					$pulldown.togglePanel()
				}
			}
		},
		components: {
			searchdetail
		},
	}
</script>